module.exports = __webpack_public_path__ + "img/icon-intelligence.43890601.svg";